import React, { useState, useRef } from 'react';
import { FlameIcon } from '../components/Icons';
import '../styles/LandingPage.css';

const LandingPage = ({ onLogin }) => {
  const [view, setView] = useState('enter'); // 'enter', 'email', 'sent'
  const [animClass, setAnimClass] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const timeoutRef = useRef(null);

  const transitionTo = (nextView) => {
    setError('');
    setAnimClass('roll-out');
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setView(nextView);
      setAnimClass('roll-in');
    }, 300);
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsLoading(true);
    setError('');
    try {
      const resp = await fetch('/.netlify/functions/api-industry-magic-link', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const data = await resp.json();
      if (data.success) {
        transitionTo('sent');
      } else {
        setError(data.message || 'Unable to send access link.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="landing-page">
      <div className="pilot-light-wordmark">Pilot Light</div>

      <div className="landing-center">
        <div className="flame-container">
          <div className="flame-icon-wrapper">
            <FlameIcon size={48} />
          </div>
          <div className="flame-glow"></div>
        </div>

        <div className="landing-content">
          <div className={`auth-stage ${animClass}`}>
            {view === 'enter' && (
              <>
                <button className="enter-button" onClick={() => transitionTo('email')}>
                  Industry Log In
                </button>
                <a href="https://pilotlight-marketplace.netlify.app"
                  style={{ display: 'inline-block', marginTop: '1.25rem', color: 'rgba(255,255,255,0.25)', fontSize: '0.78rem', textDecoration: 'none', letterSpacing: '0.06em', fontFamily: "'Cormorant Garamond', Georgia, serif", transition: 'color 0.25s' }}
                  onMouseOver={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}
                  onMouseOut={e => e.currentTarget.style.color = 'rgba(255,255,255,0.25)'}>
                  Browse more pilots on The Lot
                </a>
              </>
            )}

            {view === 'email' && (
              <form className="auth-form" onSubmit={handleEmailSubmit}>
                {error && <div className="error-message">{error}</div>}
                <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.85rem', marginBottom: '1rem', letterSpacing: '0.03em' }}>
                  Enter your email to receive an access link.
                </p>
                <div className="form-group">
                  <input
                    type="email"
                    value={email}
                    onChange={e => { setEmail(e.target.value); setError(''); }}
                    placeholder="Email address"
                    disabled={isLoading}
                    autoFocus
                    required
                  />
                </div>
                <button type="submit" className="submit-button" disabled={isLoading}>
                  {isLoading ? 'Sending...' : 'Send Access Link'}
                </button>
                <button type="button" className="back-button" onClick={() => { setError(''); setEmail(''); transitionTo('enter'); }}>Back</button>
              </form>
            )}

            {view === 'sent' && (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>&#10003;</div>
                <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
                  Access link sent to<br />
                  <span style={{ color: 'rgba(212,175,55,0.8)' }}>{email}</span>
                </p>
                <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.8rem', lineHeight: '1.5', marginBottom: '1.5rem' }}>
                  Check your inbox and click the link to enter the Screening Room. The link expires in 1 hour.
                </p>
                <button className="back-button" onClick={() => { setEmail(''); transitionTo('enter'); }}>
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
